import React from "react";
import AppStore from "../../images/home/appstore-icon.svg";
import PlayStore from "../../images/home/playstore-icon.svg";
import BrandLogo from "../../images/kikoimg.svg";
import MailGrayIcon from "../../images/home/mail-gray-icon.svg";
import WhatsappGrayIcon from "../../images/home/whatsapp-gray-icon.svg";
import FacebookIcon from "../../images/home/facebook-icon.svg";
import InstagramIcon from "../../images/home/instagram-icon.svg";
import LinkedinIcon from "../../images/home/linkedin-icon.svg";
import YoutubeIcon from "../../images/home/youtube-icon.svg";

const Footer = () => {
  return (
    <>
      <footer className="page-footer-kl">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">

            </div>
            <div className="col-lg-12">
              <div className="footer-widget-container-kl">
                <div className="footer-location-area-kl">
                  <div className="kiko-logo-kl">
                    <img src={BrandLogo} alt="Logo" className="logo-icon-kl" />
                  </div>
                  <div className="footer-location-area-text-kl">
                    <p>
                      LBS Road, Mulund, Mumbai 400080 Maharashtra, India.
                    </p>
                    <p>
                      Smooth Tag Technologies Pvt. Ltd. (CIN -
                      U72900MP2020PTC052350)
                    </p>
                  </div>
                </div>
                <div className="footer-contact-area-kl">
                  <div className="footer-contact-container-kl">
                    <div>
                      <div className="footer-contact-title-kl">
                        Contact Us
                      </div>
                      <ul className="footer-contact-list-kl">
                        <li className="footer-contact-items-kl" onClick={() => {
                          const whatsappUrl = `https://wa.me/${"+918108211231"}?text=${"Hey! I need a help on kikoshop.in"}`;
                          window.open(whatsappUrl, "_blank", "noopener,noreferrer");
                        }}>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="tel:+918108211231"
                            className="footer-contact-link-kl"
                          >
                            <img src={WhatsappGrayIcon} alt="" />{"+91 8108211231"}
                          </a>
                        </li>
                        <li className="footer-contact-items-kl">
                          <a
                            href="mailto:support@kiko.media"
                            target="_blank"
                            rel="noreferrer"
                            className="footer-contact-link-kl"
                          >
                            <img src={MailGrayIcon} alt="" />{"support@kiko.media"}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <div className="footer-contact-title-kl">
                        Legal
                      </div>
                      <ul className="footer-contact-list-kl">
                        <li className="footer-contact-items-kl">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://kiko.live/privacy-policy/"
                            className="footer-contact-link-kl"
                          >
                            Privacy Policy
                          </a>
                        </li>
                        <li className="menu-item">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://kikoshop.in/shipping-and-delivery-policy/"
                            className="footer-contact-link-kl"
                          >
                            Shipping & Delivery Policy
                          </a>
                        </li>
                        <li className="footer-contact-items-kl">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://kikoshop.in/return-policy/"
                            className="footer-contact-link-kl"
                          >
                            Return Policy
                          </a>
                        </li>
                        <li className="footer-contact-items-kl">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://kikoshop.in/terms-and-condition/"
                            className="footer-contact-link-kl"
                          >
                            Terms & Conditions
                          </a>
                        </li>
                        <li className="footer-contact-items-kl">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://kikoshop.in/refund-and-cancellation-policy/"
                            className="footer-contact-link-kl"
                          >
                            Refund and Order Cancellation Policy
                          </a>
                        </li>
                        <li className="footer-contact-items-kl">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://kiko.live/disclaimer/"
                            className="footer-contact-link-kl"
                          >
                            Disclaimer
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <section className="copyright-block-kl">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="copyright-block-inner-container">
                <p>Kiko © All Rights Reserved - 2025</p>
                <div className="footer-social-icons-kl">
                  <ul className="footer-social-icons-list-kl">
                    <li className="footer-social-icons-items-kl">
                      <a
                        href="https://facebook.com/profile.php/?id=100090104332961"
                        target="_blank"
                        rel="noreferrer"
                        className="socialIcon"
                      >
                        <img src={FacebookIcon} alt="Facebook" />
                      </a>
                    </li>
                    <li className="footer-social-icons-items-kl">
                      <a
                        href="https://www.instagram.com/kikoliveapp/"
                        target="_blank"
                        rel="noreferrer"
                        className="socialIcon"
                      >
                        <img src={InstagramIcon} alt="Instagram" />
                      </a>
                    </li>
                    <li className="footer-social-icons-items-kl">
                      <a
                        href="https://in.linkedin.com/company/kikolive"
                        target="_blank"
                        rel="noreferrer"
                        className="socialIcon"
                      >
                        <img src={LinkedinIcon} alt="LinkedIn" />
                      </a>
                    </li>
                    <li className="footer-social-icons-items-kl">
                      <a
                        href="https://www.youtube.com/@kikolive5631"
                        target="_blank"
                        rel="noreferrer"
                        className="socialIcon"
                      >
                        <img src={YoutubeIcon} alt="Youtube" />
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="download-app-buttons-list-kl">

                  <div className="download-app-buttons-items">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://play.google.com/store/apps/details?id=live.kiko.user&pcampaignid=web_share"
                      className="download-app-buttons-link-kl"
                    >
                      <img src={PlayStore} alt="Play Store" />
                    </a>
                  </div>

                  <div className="download-app-buttons-items-kl">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://apps.apple.com/in/app/kiko-live/id1567183166"
                      className="download-app-buttons-link-kl"
                    >
                      <img src={AppStore} alt="App Store" />
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Footer;
